import { _isNumberValue } from "@angular/cdk/coercion";
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
@Component({
  selector: "cargoes-pagination-jumper",
  templateUrl: "./pagination-jumper.component.html",
  styleUrls: ["./pagination-jumper.component.less"],
})
export class PaginationJumperComponent implements OnChanges {
  minValue: number = 1;
  maxValue: number = 1;
  stepValue: number = 1;
  jumperValue: any = null;
  @Input() pageIndex: number = 1;
  @Input() totalElements: number = 0;
  @Input() pageSize: number = 10;
  @Output() onPageIndexChanged = new EventEmitter();

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['pageIndex']) {
      this.pageIndex = changes['pageIndex'].currentValue;
    }
    if (changes['pageSize']) {
      this.pageSize = changes['pageSize'].currentValue;
    }
    if (changes['totalElements']) {
      this.totalElements = changes['totalElements'].currentValue;
    }
    if (this.totalElements && this.pageSize) {
      this.maxValue = Math.ceil(this.totalElements / this.pageSize);
    }
    this.clearJumpToInput();
  }

  clearJumpToInput() {
    this.jumperValue=null;
  }

  pageIndexChanged(pageNumber: number) {
    this.onPageIndexChanged.emit(pageNumber);
  }

  jumpToPage(): void {
    const pageNumber = Math.floor(this.toNumber(this.jumperValue, this.pageIndex));
    this.onPageIndexChanged.emit(pageNumber);
    this.clearJumpToInput();
  }

  toNumber(value: number | string, fallbackValue: number = 0): number {
    return _isNumberValue(value) ? Number(value) : fallbackValue;
  }

  onKeyUp(event: any) {
    const key = event.which || event.keyCode;
    return key >= 48 && key <= 57 ? true : false
  }
}
